module.exports = __webpack_public_path__ + "img/Total Cost Icon.330f93fc.png";